const ordersPageStyle = (theme) => ({
  page: {
    minHeight: "100vh",
    display: "grid",
    gridTemplateColumns: "232px minmax(0, 1fr)",
    background: "#f6f8fb",
    color: "#172033",
    transition: "grid-template-columns 160ms ease",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  pageCollapsed: {
    gridTemplateColumns: "74px minmax(0, 1fr)",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  sidebar: {
    position: "sticky",
    top: 0,
    height: "100vh",
    padding: "16px 14px 22px",
    background: "#111827",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    [theme.breakpoints.down("sm")]: {
      position: "relative",
      height: "auto",
      padding: 14,
    },
  },
  sidebarCollapsed: {
    "& $brandWrap": { justifyContent: "center" },
    "& $logo": { display: "none" },
    "& $navList button": {
      justifyContent: "center",
      padding: 0,
      fontSize: 0,
    },
    "& $logoutButton": {
      fontSize: 0,
      padding: 0,
    },
  },
  sidebarToggle: {
    width: 40,
    height: 40,
    border: "1px solid rgba(255,255,255,0.16)",
    borderRadius: 6,
    background: "transparent",
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& svg": { width: 20, height: 20 },
  },
  brandWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
  },
  logo: {
    width: 72,
    height: 38,
    objectFit: "contain",
    background: "#fff",
  },
  navList: {
    display: "grid",
    gap: 8,
    "& button": {
      height: 42,
      border: 0,
      borderRadius: 6,
      padding: "0 12px",
      background: "transparent",
      color: "#cbd5e1",
      display: "flex",
      alignItems: "center",
      gap: 10,
      cursor: "pointer",
      textAlign: "left",
      "& svg": { width: 18, height: 18 },
      "&:disabled": { opacity: 0.45, cursor: "not-allowed" },
    },
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
      "& button": { justifyContent: "center", fontSize: 12, padding: "0 6px" },
    },
  },
  navActive: {
    background: "#2563eb !important",
    color: "#fff !important",
  },
  logoutButton: {
    marginTop: "auto",
    height: 40,
    border: "1px solid rgba(255,255,255,0.18)",
    borderRadius: 6,
    background: "transparent",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    cursor: "pointer",
    "& svg": { width: 18, height: 18 },
  },
  mainPanel: {
    minWidth: 0,
    padding: "28px 30px 42px",
    [theme.breakpoints.down("sm")]: { padding: 16 },
  },
  topBar: {
    minHeight: 64,
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    alignItems: "flex-start",
    "& h1": {
      margin: 0,
      fontSize: 28,
      fontWeight: 800,
      lineHeight: 1.2,
      letterSpacing: 0,
    },
    "& p": { margin: "8px 0 0", color: "#64748b" },
  },
  emailPrompt: {
    position: "fixed",
    top: 18,
    right: 18,
    zIndex: 10,
    width: 300,
    padding: "14px 42px 14px 14px",
    borderRadius: 8,
    border: "1px solid #fed7aa",
    background: "#fff7ed",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.16)",
    display: "grid",
    gap: 6,
    "& span": { color: "#9a3412", fontSize: 13 },
    [theme.breakpoints.down("sm")]: {
      position: "static",
      width: "auto",
      margin: "12px 0",
    },
  },
  emailPromptAction: {
    border: 0,
    background: "transparent",
    color: "#c2410c",
    padding: 0,
    textAlign: "left",
    fontWeight: 700,
    cursor: "pointer",
  },
  emailPromptClose: {
    position: "absolute",
    top: 8,
    right: 8,
    width: 28,
    height: 28,
    border: 0,
    borderRadius: 6,
    background: "transparent",
    color: "#9a3412",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& svg": { width: 18, height: 18 },
    "&:hover": { background: "#ffedd5" },
  },
  notice: {
    marginTop: 14,
    padding: "10px 12px",
    borderRadius: 6,
    background: "#ecfeff",
    color: "#155e75",
    border: "1px solid #a5f3fc",
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 14,
    marginTop: 22,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    },
  },
  summaryCard: {
    minHeight: 78,
    padding: 16,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    background: "#fff",
    display: "grid",
    gap: 8,
    "& span": { color: "#64748b", fontSize: 12, textTransform: "uppercase" },
    "& strong": { fontSize: 22, lineHeight: 1.1 },
  },
  filterBar: {
    marginTop: 18,
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
    padding: 14,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    background: "#fff",
  },
  iconButton: {
    height: "40px !important",
    margin: "0 !important",
    borderRadius: "6px !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    gap: "6px !important",
    "& svg": { width: 17, height: 17 },
  },
  downloadButton: {
    height: "40px !important",
    margin: "0 !important",
    borderRadius: "6px !important",
    border: "1px solid #2563eb !important",
    background: "#fff !important",
    color: "#1d4ed8 !important",
    boxShadow: "none !important",
    display: "inline-flex !important",
    alignItems: "center !important",
    gap: "6px !important",
    "& svg": { width: 17, height: 17 },
  },
  contentPanel: {
    marginTop: 18,
  },
  tableWrap: {
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    boxShadow: "none",
    overflowX: "auto",
  },
  table: {
    minWidth: 920,
    "& th": {
      fontWeight: 700,
      color: "#475569",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    "& td": { color: "#334155" },
  },
  invoiceButton: {
    border: 0,
    background: "transparent",
    color: "#1d4ed8",
    padding: 0,
    fontWeight: 700,
    cursor: "pointer",
  },
  statusPill: {
    fontWeight: 700,
    whiteSpace: "nowrap",
  },
  textLink: {
    color: "#1d4ed8",
    cursor: "pointer",
    textDecoration: "underline",
  },
  emptyState: {
    padding: 28,
    color: "#64748b",
    textAlign: "center",
  },
  mapWrapper: {
    height: 520,
    borderRadius: 8,
    overflow: "hidden",
    border: "1px solid #e2e8f0",
    background: "#e5e7eb",
  },
  fileGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 14,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  fileGroup: {
    padding: 16,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    background: "#fff",
    "& h3": { margin: "0 0 12px", fontSize: 16 },
  },
  fileButton: {
    width: "100%",
    minHeight: 36,
    border: 0,
    borderTop: "1px solid #f1f5f9",
    background: "transparent",
    color: "#1d4ed8",
    display: "flex",
    alignItems: "center",
    gap: 8,
    textAlign: "left",
    cursor: "pointer",
    "& svg": { width: 17, height: 17, flex: "0 0 auto" },
  },
  profileGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 14,
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "1fr" },
  },
  profileSection: {
    padding: 18,
    borderRadius: 8,
    border: "1px solid #e2e8f0",
    background: "#fff",
    "& h3": { margin: "0 0 12px", fontSize: 17 },
  },
  actionButton: {
    margin: "12px 0 0 !important",
    borderRadius: "6px !important",
  },
  verifyText: {
    marginTop: 10,
    color: "#64748b",
    fontSize: 13,
  },
  supportBox: {
    marginTop: 16,
    paddingTop: 14,
    borderTop: "1px solid #e2e8f0",
    display: "grid",
    gap: 5,
    "& strong": { color: "#172033" },
    "& span": { color: "#64748b", fontSize: 13, lineHeight: 1.5 },
    "& span strong": { fontWeight: 800 },
  },
  apiDocLink: {
    color: "#1d4ed8",
    fontWeight: 700,
    textDecoration: "underline",
  },
  dialogTitle: {
    padding: "18px 22px 12px",
    borderBottom: "1px solid #e2e8f0",
    display: "flex",
    justifyContent: "space-between",
    gap: 16,
    "& h2": { margin: 0, fontSize: 20, fontWeight: 800, letterSpacing: 0 },
    "& p": { margin: "5px 0 0", color: "#64748b", fontSize: 13 },
  },
  dialogClose: {
    width: 34,
    height: 34,
    border: 0,
    borderRadius: 6,
    background: "transparent",
    color: "#475569",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    "& svg": { width: 20, height: 20 },
    "&:hover": { background: "#f1f5f9" },
  },
  dialogContent: {
    padding: "18px 22px 22px !important",
  },
  trackingList: {
    display: "grid",
    gap: 14,
  },
  trackingItem: {
    display: "grid",
    gridTemplateColumns: "18px 1fr",
    gap: 12,
    alignItems: "start",
    "& strong": { color: "#172033" },
    "& p": { margin: "4px 0 0", color: "#64748b" },
    "& h3": { margin: "10px 0 0", fontSize: 15, letterSpacing: 0 },
  },
  trackingDot: {
    width: 12,
    height: 12,
    marginTop: 4,
    borderRadius: "50%",
    border: "2px solid #94a3b8",
    background: "#fff",
  },
  trackingDotDone: {
    borderColor: "#14804a",
    background: "#14804a",
  },
  readOnlyList: {
    display: "grid",
    gridTemplateColumns: "90px 1fr",
    gap: "8px 12px",
    margin: 0,
    "& dt": { color: "#64748b" },
    "& dd": { margin: 0, color: "#172033" },
  },
});

export default ordersPageStyle;
